import { fetch } from '../config/axios'

// 话费套餐
export function rechargePackageList (params) {
  return fetch(params, '/rechargePackageList')
}

// 充值
export function rechargeTele (params) {
  return fetch(params, '/rechargeTele', true)
}
// 充值记录
export function rechargeRecordList (params) {
  return fetch(params, '/rechargeRecordList', true)
}

// 信用卡列表
export function creditCardList (params) {
  return fetch(params, '/creditCardList', true)
}
// 办卡记录列表
export function creditCardOrderList (params) {
  return fetch(params, '/creditCardOrderList', true)
}
// 极速申请信用卡
export function applyCreditCard (params) {
  return fetch(params, '/applyCreditCard', true)
}
// 出行
export function getAuthInfo (params) {
  return fetch(params, '/getAuthInfo', true)
}

// 折淘客获取活动api：如饿了么
export function getHdongUrl (params) {
  return fetch(params, '/getHdongUrl', true)
}



// WEBPACK FOOTER //
// ./src/api/third.js